import {
  amazonIcon,
  appleMusicIcon,
  dropboxIcon,
  facebookIcon,
  facebookMessengerIcon,
  googleChromeIcon,
  googleDriveIcon,
  googleGmailIcon,
  googleMapsIcon,
  googleTranslateIcon,
  instagramIcon,
  lineIcon,
  linkedInIcon,
  lyftIcon,
  netflixIcon,
  payPalIcon,
  redditIcon,
  safariIcon,
  skypeIcon,
  slackIcon,
  snapchatIcon,
  spotifyIcon,
  tikTokIcon,
  twitterIcon,
  uberIcon,
  wazeIcon,
  weChatIcon,
  whatsAppIcon,
  yelpIcon,
  youTubeIcon,
  zoomIcon,
} from 'resources/images'

export const APP_KEYS = {
  AMAZON: 'amazon',
  APPLE_MUSIC: 'appleMusic',
  DROPBOX: 'dropbox',
  FACEBOOK: 'facebook',
  FACEBOOK_MESSENGER: 'facebookMessenger',
  GOOGLE_CHROME: 'googleChrome',
  GOOGLE_DRIVE: 'googleDrive',
  GOOGLE_GMAIL: 'googleGmail',
  GOOGLE_MAPS: 'googleMaps',
  GOOGLE_TRANSLATE: 'googleTranslate',
  INSTAGRAM: 'instagram',
  LINE: 'line',
  LINKED_IN: 'linkedIn',
  LYFT: 'lyft',
  NETFLIX: 'netflix',
  PAY_PAL: 'payPal',
  REDDIT: 'reddit',
  SAFARI: 'safari',
  SKYPE: 'skype',
  SLACK: 'slack',
  SNAPCHAT: 'snapchat',
  SPOTIFY: 'spotify',
  TIK_TOK: 'tikTok',
  TWITTER: 'twitter',
  UBER: 'uber',
  WAZE: 'waze',
  WE_CHAT: 'weChat',
  WHATS_APP: 'whatsApp',
  YELP: 'yelp',
  YOU_TUBE: 'youTube',
  ZOOM: 'zoom',
}

export const APP_ICON_MAPPING = {
  [APP_KEYS.AMAZON]: amazonIcon,
  [APP_KEYS.APPLE_MUSIC]: appleMusicIcon,
  [APP_KEYS.DROPBOX]: dropboxIcon,
  [APP_KEYS.FACEBOOK]: facebookIcon,
  [APP_KEYS.FACEBOOK_MESSENGER]: facebookMessengerIcon,
  [APP_KEYS.GOOGLE_CHROME]: googleChromeIcon,
  [APP_KEYS.GOOGLE_DRIVE]: googleDriveIcon,
  [APP_KEYS.GOOGLE_GMAIL]: googleGmailIcon,
  [APP_KEYS.GOOGLE_MAPS]: googleMapsIcon,
  [APP_KEYS.GOOGLE_TRANSLATE]: googleTranslateIcon,
  [APP_KEYS.INSTAGRAM]: instagramIcon,
  [APP_KEYS.LINE]: lineIcon,
  [APP_KEYS.LINKED_IN]: linkedInIcon,
  [APP_KEYS.LYFT]: lyftIcon,
  [APP_KEYS.NETFLIX]: netflixIcon,
  [APP_KEYS.PAY_PAL]: payPalIcon,
  [APP_KEYS.REDDIT]: redditIcon,
  [APP_KEYS.SAFARI]: safariIcon,
  [APP_KEYS.SKYPE]: skypeIcon,
  [APP_KEYS.SLACK]: slackIcon,
  [APP_KEYS.SNAPCHAT]: snapchatIcon,
  [APP_KEYS.SPOTIFY]: spotifyIcon,
  [APP_KEYS.TIK_TOK]: tikTokIcon,
  [APP_KEYS.TWITTER]: twitterIcon,
  [APP_KEYS.UBER]: uberIcon,
  [APP_KEYS.WAZE]: wazeIcon,
  [APP_KEYS.WE_CHAT]: weChatIcon,
  [APP_KEYS.WHATS_APP]: whatsAppIcon,
  [APP_KEYS.YELP]: yelpIcon,
  [APP_KEYS.YOU_TUBE]: youTubeIcon,
  [APP_KEYS.ZOOM]: zoomIcon,
}
